import moment from "moment";

export const formatDate = (value) => {
  return value ? moment(value).format("YYYY-MM-DD") : "---";
};

export const formatTime = (value) => {
  return value ? moment(value).format("hh:mm A") : "---";
};

export const formatNumber = (num) => {
  if (!num) return "0"; // 0 → ""

  // For numbers below 1000: return as-is with no decimals
  if (num < 1000) {
    return num.toString();
  }

  // For 1000+ use compact notation with 1 decimal
  return new Intl.NumberFormat("en", {
    notation: "compact",
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  }).format(num);
};
